import { CONSTANTS } from '@toolproof-core/lib/_data/lookups';

export const TYPE_WorkflowTrace = CONSTANTS.Handles.ResourceTypes.TYPE_WorkflowTrace;
export const TYPE_ResourceType = CONSTANTS.Handles.ResourceTypes.TYPE_ResourceType;
export const TYPE_Tool = CONSTANTS.Handles.ResourceTypes.TYPE_Tool;
